/**
 * Create the body content for the Joki event sent to GraphQLService
 *
 * GraphQLService only takes in the query string in the body.
 *
 */
export function parseGraphQlEndpointData(endpoint, body, filters) {
    if (filters !== null && typeof filters === "object") {
        const keys = Object.keys(filters);
        if (keys.length > 0) {
            const filterString = keys
                .reduce((all, k) => {
                    const v = filters[k];
                    if (v !== null) {
                        all.push(`${k}: ${v}`);
                    }
                    return all;
                }, [])
                .join(", ");
            return {
                query: endpoint.query.replace("$FILTERS$", `(${filterString})`),
                body: body,
                url: endpoint.url,
            };
        }
    }
    return {
        query: endpoint.query.replace("$FILTERS$", ``),
        body: body,
        url: endpoint.url,
    };
}
